import FeaturedImage from './FeaturedImage'

export default FeaturedImage
